<template>
  <div class="tours-list dt-page">
    <v-layout row wrap>
      <div row wrap class="artist-top-bar">
        <div class="add-button">
          <img @click="onAddNewPromoterClicked" class="dt-icon" src="static/buttons/add.svg" alt />
        </div>
        <div class="search">
          <InputField
            :value="searchString"
            :placeholder="$t('search')"
            :config="{
                  borderStyle: 'around'
              }"
            @keyup="onSearchInputKeyup"
          ></InputField>
        </div>

        <div class="right-space"></div>
      </div>
    </v-layout>

    <!-- <v-card-title>
      <v-flex xs3>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <div class="add-button">
        <img @click="onAddNewPromoterClicked" class="dt-icon" src="static/buttons/add.svg" alt />
      </div>
    </v-card-title>-->

    <div class="tours-list dt-page--data-table">
      
    </div>

    <v-dialog v-model="sendPermissionModalOpen" width="800">
      <SendPermissionModal
        :selected-item="sendPermissionModalData"
        @cancelled="sendPermissionModalOpen = false"
      />
    </v-dialog>

    <v-dialog v-model="addNewPromoterModalOpen" width="800">
      <AddNewPromoterModal
        :list-items="promotersContactData"
        @cancelled="onAddNewPromoterCancelled()"
        @loadMore="loadMoreContactForPromoter"
        @searched="setSearchContactForPromoter"
      />
    </v-dialog>

    <v-navigation-drawer
      temporary
      right
      :clipped="clipped"
      :width="1000"
      :value="promoterDetailsFlag"
      fixed
      stateless
      hide-overlay
      app
    >
      <PromoterSidewindow @cancelled="onBookingPromoterDetailClose"></PromoterSidewindow>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { BookingStoreNamespace as storeNS } from "../store";
import { mapActions, mapGetters, mapMutations } from "vuex";
import * as ActionTypes from "../store/types";

import Dropdown from "@plugins/dropdown/dropdown";
import InputField from "@plugins/text-field/input-field";

import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../plugins/datatable";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime, window } from "rxjs/operators";

import {
  bookingPromoterRoute,
  bookingPromoterDetailsRoute,
  bookingPromoterDetailsTabRoute
} from "../router/router";
import { childOfOrEqual } from "../../../router/functions";
import { bookingPromotersService } from "../services/booking-promoters.service";
import { createMailHref } from "../../../utility";
import SendPermissionModal from "../components/promoters/send-permission";
import AddNewPromoterModal from "../components/promoters/add-new";

import PromoterSidewindow from "../components/promoters/promoter-sidewindow/promoter-sidewindow";
import promoterSidewindowVue from "../components/promoters/promoter-sidewindow/promoter-sidewindow.vue";
// import SendDocumentFiles from "../components/send-doc-files";

// import {
//   getBookingStatuses,
//   mapBookingToIds,
//   previous10YearsMonthsDropdown,
//   createDropdownItem
// } from "../models/booking-artist.model";
// import { childOf, childOfOrEqual } from "../../../router/functions";

// console.log(getBookingStatuses());

const listLength = 100;

export default {
  components: {
    Dropdown,
    InputField,
    NTable,
    SendPermissionModal,
    AddNewPromoterModal,
    PromoterSidewindow
  },
  data: function() {
    return {
      headers: [
        { value: "promoter_name", text: this.$t("promoter"), width: "25%" },
        { value: "country", text: this.$t("country"), width: "15%" },
        { value: "city", text: this.$t("city"), width: "10%" },
        { value: "address1", text: this.$t("address"), width: "20%" },
        { value: "phone1", text: this.$t("phone1"), width: "15%" },
        { value: "phone2", text: this.$t("phone2"), width: "15%" },
        { value: "item_actions", text: "", width: "13%", sortable: false }
      ],
      promotersData: [],
      promotersContactData: [],
      sendPermissionModalOpen: false,
      addNewPromoterModalOpen: false,
      sendPermissionModalData: {
        emailbody:
          "Dear Promoter, \r\nhere is an invitation to connect with us via DETAILS and be able to sign contracts online as well as view your invoices with us.",
        title: "",
        subject: "",
        promoter_id: null,
        contact_id: null,
        email: null
      },
      startFrom: 0,
      // search: "",
      searchString: "",
      searchSubject$: new Subject(),
      searchContactForPromoter: "",
      clipped: false
    };
  },
  mounted: function() {
    this[ActionTypes.GET_BOOKING_PROMOTERS]();

    this.$subscribeTo(
      this.searchSubject$.asObservable().pipe(
        distinctUntilChanged(),
        debounceTime(350)
      ),
      searchString => {
        this.searchPromoter(searchString);
      }
    );
    this.fetchData();
  },
  beforeDestroy() {},
  computed: {
    ...mapGetters(storeNS, {
      bookingPromoters: "bookingPromoters",
      clientDisplayName: "clientDisplayName",
      contactsForPromoter: "contactsForPromoter",
      promoters_list_start_from: "promoters_list_start_from"
    }),
    promoterDetailsFlag: function() {
      return childOfOrEqual(bookingPromoterDetailsRoute)(this.$route.name);
    }
  },
  watch: {
    bookingPromoters: function(newVal) {
      this.promotersData = newVal;
    },
    contactsForPromoter: function(newVal) {
      this.promotersContactData = newVal;
    },
    // search: function(newval, oldval) {
    //   if (newval.length > 2 && newval != oldval) {
    //     bookingPromotersService.searchPromoters(newval).then(res => {
    //       this.promotersData = res.data;
    //     });
    //   } else if (newval == "" || newval.length == 0) {
    //     this.promotersData = this.bookingPromoters;
    //   }
    // },
    searchContactForPromoter: function(newval, oldval) {
      if (newval.length > 2 && newval != oldval) {
        bookingPromotersService.searchContactForPromoter(newval).then(res => {
          this.promotersContactData = res.data;
        });
      } else if (newval == "" || newval.length == 0) {
        this.promotersContactData = this.contactsForPromoter;
      }
    },
    $route: {
      immediate: true,
      handler: function(to, from) {
        // console.log(to, from);
        const promoterID = to.params.promoter_id;
        if (
          promoterID &&
          (!from || (from && from.params.promoter_id != promoterID))
        ) {
          this.setSlectedPromoter(promoterID);
        }

        this.addNewPromoterModalOpen = to.query.modal === "add_promoter";
        if (this.addNewPromoterModalOpen) {
          this.openAddNewPromoterMoldal();
        }
      }
    }
  },
  methods: {
    ...mapActions(storeNS, {
      [ActionTypes.GET_BOOKING_PROMOTERS]: ActionTypes.GET_BOOKING_PROMOTERS,
      [ActionTypes.DELETE_BOOKING_PROMOTER]:
        ActionTypes.DELETE_BOOKING_PROMOTER,
      [ActionTypes.GET_CONTACTS_FOR_PROMOTER]:
        ActionTypes.GET_CONTACTS_FOR_PROMOTER,
      [ActionTypes.SET_BOOKING_PROMOTER_SELECTED]:
        ActionTypes.SET_BOOKING_PROMOTER_SELECTED
    }),

    ...mapMutations(storeNS, {
      [ActionTypes.SET_ROUTE_QUERY_MODAL]: ActionTypes.SET_ROUTE_QUERY_MODAL
    }),

    onChangeRoutes(route) {
      this[ActionTypes.SET_ROUTE_QUERY_MODAL](route.query.modal);
    },

    onSearchInputKeyup: function(event) {
      this.searchString = event.target.value;
      this.searchSubject$.next(this.searchString);
    },

    searchPromoter(newval) {
      if (newval.length > 2) {
        bookingPromotersService.searchPromoters(newval).then(res => {
          this.promotersData = res.data;
        });
      } else if (newval == "" || newval.length == 0) {
        this.promotersData = this.bookingPromoters;
      }
    },

    onPromotersScroll() {
      if (this.promoters_list_start_from == this.startFrom) {
        this.startFrom += listLength;
        this[ActionTypes.GET_BOOKING_PROMOTERS](this.startFrom);
      }
    },

    setSlectedPromoter(promoterID) {
      // const sb = this.bookingArtistList.find(e => e.calendar_date_id == calendar_date_id);
      // if (sb) {
      //   this[ActionTypes.SET_SELECTED_BOOKING](sb);
      // } else {
      //   this[ActionTypes.SET_SELECTED_BOOKING]({calendar_date_id});
      // }
      this[ActionTypes.SET_BOOKING_PROMOTER_SELECTED](promoterID);
    },

    getPromoterName(item) {
      return item.company_name
        ? item.company_name
        : item.first_name + " " + item.last_name;
    },

    getPromoterEmail(item) {
      return item.p_email ? item.p_email : item.c_email;
    },

    onRowClicked(item) {
      this.$router.push({
        name: bookingPromoterDetailsTabRoute,
        params: {
          promoter_id: item.promoter_id,
          tab: this.$route.params.tab ? this.$route.params.tab : "overview"
        }
      });
    },

    onBookingPromoterDetailClose() {
      this.$router.push({ name: bookingPromoterRoute });
    },

    onActionIconClicked(action, item) {
      switch (action) {
        case "handshake":
          this.sendPermissionModalData.email = this.getPromoterEmail(item);
          this.sendPermissionModalData.title =
            "TO: " + this.sendPermissionModalData.email;
          this.sendPermissionModalData.subject =
            this.clientDisplayName +
            " requests that you work together with the DETAILS Promoter App";
          this.sendPermissionModalData.promoter_id = item.promoter_id;
          this.sendPermissionModalData.contact_id = item.contact_id;
          this.sendPermissionModalOpen = true;
          break;
        case "email":
          bookingPromotersService
            .getLoginLink(item.promoter_id, this.getPromoterEmail(item))
            .then(res => {
              location.href = createMailHref({
                mails: [res.data.email],
                subject: res.data.subject,
                body: res.data.booking_link2
              });
            });
          break;
        case "delete":
          this[ActionTypes.DELETE_BOOKING_PROMOTER](item.promoter_id);
          // console.log(item.promoter_id);
          break;
      }
      // console.log(item);
    },

    // handleScroll() {
    //   this.scrolled = window.scrollY > 0;
    //   var sh = document.querySelector(".booking-container").scrollHeight;
    //   var st = document.querySelector(".booking-container").scrollTop;
    //   var oh = document.querySelector(".booking-container").offsetHeight;
    //   // console.log("scrolling.." + (sh - st - oh + 1));
    //   if (sh - st - oh + 1 < 2) {
    //     console.log("loadig new items....");
    //     this[ActionTypes.GET_BOOKING_PROMOTERS](this.bookingPromoters.length);
    //   }
    // },
    onAddNewPromoterClicked() {
      this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, modal: "add_promoter" }
      });
    },
    openAddNewPromoterMoldal() {
      this.addNewPromoterModalOpen = true;
      this[ActionTypes.GET_CONTACTS_FOR_PROMOTER]();
    },
    onAddNewPromoterCancelled() {
      this.$router.replace({ query: null });
    },
    loadMoreContactForPromoter(startFrom) {
      this[ActionTypes.GET_CONTACTS_FOR_PROMOTER](
        // this.contactsForPromoter.length
        startFrom
      );
    },
    setSearchContactForPromoter(searchKey) {
      this.searchContactForPromoter = searchKey;
    },

    fetchData(){
       this[ActionTypes.BOOKING_TOURS.FETCH.ALL]();
    }
  }
};
</script>

<style lang="scss" scoped>
.dt-ntable.promoters-list {
  --ntable-height: calc(100vh - 135px);
  td:first-child {
  }

  td.options {
    display: flex;
    flex-direction: row;
    .dt-icon-container {
      flex: 0.25;
    }
    img.handshake {
      max-height: 24px;
    }
    .loading-icon-container {
      flex: 1;
      .loading-icon {
        max-width: 15px;
        max-height: 15px;
        margin-top: 10px;
        margin-left: 16px;
      }
    }
  }
}
.top-bar {
  display: flex;
  // background: wheat;
  margin-left: 15px;
  margin-bottom: 10px;

  color: var(--text-primary);

  .add-button {
    flex: 0.015;
    img {
      margin-top: 5px;
    }
  }

  .search {
    flex: 5;
    max-width: 80px;
    margin:0px 20px;
  }

  .dropdown {
    flex: 5;
    max-width: 127px;
    margin: 0px 20px;
    .dropdown--main {
      border-bottom: 1px solid var(--sprt-5);
    }
  }
}

.dt-table {
  --rest-cell-padding: 0px 5px;
  --tb-layout: fixed;
}

.booking-table {
  td {
    line-height: 8px;
  }



  .booking_process {
    img.mail-icon {
      margin-left: 10px;
      width: 24px;
      height: 40px;
    }
  }
}
</style>
